import React from 'react';

export function StepMainFacilityEditLabel() {
  return (
    <>
      Provozovna k rozdělení - <b>Editace</b>
    </>
  );
}
